export const ApiUrl = 
  "https://alumni.developer-ourbase-camp.com/api" ||
  "http://localhost:4000";
export const ImageUrl =
  " https://alumni.developer-ourbase-camp.com/szabist/images" ||
  "http://localhost:4000";
